<template>
  <component
    :is="currentView"
    :partId="partId"
    :newPart="newPart"
    @save="$emit('save', $event)"
    @cancel="$emit('cancel')"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import FormTemplateSection from './FormTemplateSection'
import FormTemplateQuestion from './FormTemplateQuestion'
import FormTemplateParagraph from './FormTemplateParagraph'
import FormTemplateEsignature from './FormTemplateEsignature'
import FormTemplatePageBreak from './FormTemplatePageBreak'

export default {
  name: 'FormTemplatePart',
  props: [ 'partId', 'newPart' ],
  components: {
    FormTemplateSection,
    FormTemplateQuestion,
    FormTemplateParagraph,
    FormTemplateEsignature,
    FormTemplatePageBreak
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById'
    ]),
    part: function () {
      return this.partById(this.partId) || this.newPart
    },
    currentView: function () {
      switch (this.part.part_type) {
        case 's': return 'FormTemplateSection'
        case 'q': return 'FormTemplateQuestion'
        case 'p': return 'FormTemplateParagraph'
        case 'e': return 'FormTemplateEsignature'
        case 'b': return 'FormTemplatePageBreak'
        default: return null
      }
    }
  }
}
</script>
